// extracted by mini-css-extract-plugin
export default {"rating":"aH-z","numberOfStars":"bH-z","count":"cH-z","barGraphSpacing":"dH-z","barGraph":"eH-z"};